import * as THREE from 'three'
import Frame from './Frame'
import Box from './Box'
import Scene from './Scene'
import Camera from './Camera'
import Controller from './Controller'
import Renderer from './Renderer'
import ClogGenerator from './ClogGenerator'
import ClampGenerator from './ClampGenerator'
import Generator from './Generator'

class Three {
  private canvas: HTMLCanvasElement
  private scene: Scene
  private camera: Camera
  private renderer: Renderer
  private controller: Controller

  public constructor() {
    this.canvas = document.createElement('canvas')
    this.scene = new Scene()
    this.camera = new Camera()
    this.controller = new Controller(this.camera.camera, this.canvas)
    this.renderer = new Renderer(this.canvas, this.scene, this.camera, this.controller)
  }

  public createImage(frame: Frame, box: Box): Promise<string> {
    this.renderer.stop()
    return new Promise((resolve, reject) => {
      this.render(frame, box)
      frame.snapshot().then((image: HTMLImageElement) => {
        this.renderer.stop()
        return resolve(image.src)
      })
    })
  }

  public activate(frame: Frame, box: Box): Promise<void> {
    this.renderer.stop()
    return new Promise((resolve, reject) => {
      this.render(frame, box)
      return resolve()
    })
  }

  public deactivate() {
    this.renderer.stop()
  }

  private render(frame: Frame, box: Box): void {
    frame.attach(this.canvas)
    this.scene.clear()
    this.camera.resize(frame.width, frame.height)
    this.renderer.resize(frame.width, frame.height)

    // グループを作成
    const group = new THREE.Group()
    group.castShadow = true

    const generator = new Generator()
    // 箱
    const box3d = generator.createBox3d(frame, box)
    group.add(box3d)

    const boxWireFrame = generator.createBoxWireFrame(frame, box)
    group.add(boxWireFrame)

    // 桁
    const clogs = new ClogGenerator().create(frame, box)
    for (let clog of clogs) {
      group.add(clog)
    }

    // クランプ
    const clamps = new ClampGenerator().create(frame, box)
    for (let clamp of clamps) {
      group.add(clamp)
    }

    this.scene.add(group)

    // 地面を生成
    if (!frame.grayscale) {
      const ground = generator.createGround()
      ground.position.y = (box.outer.y / 2 + box.clog.getHeight()) * frame.scale * -1
      this.scene.add(ground)
    }

    // ----------------------------------------
    // カメラを補正・レンダリング開始
    // ----------------------------------------
    const lookAt = boxWireFrame.position
    boxWireFrame.geometry.computeBoundingBox()
    const box3 = boxWireFrame.geometry.boundingBox
    this.camera.cameraFitToBox(lookAt, box3)
    this.controller.update()
    this.renderer.start()
  }
}

export default new Three()



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Three.ts